import { type SystemIncidentDto } from "../models";
import { doGet } from "./httpHandler";

export class SystemIncidentsApi {
    public static getAlerts = async () => {
        return await doGet<SystemIncidentDto[]>("/api/SystemIncidents", "Active");
    };
}
